// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"51b507f3","453":"8e724996"}[chunkId] + ".chunk.js";
};